import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type BonusEnabledResponse = {
  bonus_enabled: boolean;
} | null;

const fetchBonusEnabled = async (
  user_id: string,
): Promise<BonusEnabledResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.get(
    API_ROUTES.USER_BONUS_ENABLED.replace("{user_id}", user_id),
  );

  return response?.data ?? null;
};

export const useGetBonusEnabled = (
  user_id?: string | null,
  enabled: boolean = true,
) =>
  useQuery<BonusEnabledResponse, Error>({
    queryKey: ["bonusEnabled", user_id],
    queryFn: () => fetchBonusEnabled(user_id as string),
    enabled: Boolean(user_id) && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
